import React from 'react';
import { formatCurrency, formatPercent, healthTone } from '../lib/executiveCommandCenterFormatters';

const MetricCard = ({ label, value, hint, tone = 'text-slate-100', prominent = false }) => (
  <div className={`rounded-xl border border-slate-800 bg-slate-900/70 p-3 ${prominent ? 'ring-1 ring-cyan-500/40' : ''}`}>
    <div className="text-[11px] uppercase tracking-wide text-slate-400">{label}</div>
    <div className={`mt-1 text-xl font-semibold ${tone}`}>{value}</div>
    <div className="mt-1 text-xs text-slate-500">{hint}</div>
  </div>
);

const ExecutiveSummaryBar = ({ summary }) => {
  const data = summary || {};
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-7">
      <MetricCard label="Active Customers" value={Number(data.total_active_customers || 0).toLocaleString('id-ID')} hint="Basis layanan aktif" tone="text-emerald-200" />
      <MetricCard label="MRR" value={formatCurrency(data.monthly_recurring_revenue)} hint="Recurring revenue estimasi" tone="text-cyan-200" />
      <MetricCard
        label="Collection Rate"
        value={formatPercent(data.collection_rate)}
        hint="Efektivitas penagihan"
        tone={healthTone(data.collection_rate, 80, 92)}
        prominent
      />
      <MetricCard label="Active Incidents" value={Number(data.current_network_incident_count || 0)} hint="Insiden non-normal saat ini" tone="text-amber-200" />
      <MetricCard label="SLA Breach" value={Number(data.active_sla_breach_count || 0)} hint="Ticket melewati SLA" tone="text-rose-200" />
      <MetricCard label="Activation Pipeline" value={Number(data.activation_pipeline_count || 0)} hint="Prospek belum selesai" tone="text-indigo-200" />
      <MetricCard label="Revenue at Risk" value={formatCurrency(data.revenue_at_risk)} hint={`Churn Signal ${data.churn_risk_signal || '-'}`} tone="text-red-300" prominent />
    </div>
  );
};

export default ExecutiveSummaryBar;
